import { Component, OnInit, ViewChild } from '@angular/core';
import { CalendarOptions, FullCalendarComponent } from '@fullcalendar/angular';
import { RsbService } from 'src/app/service/rsb.service';
import { RsbLookupModel } from 'src/app/common/model/rsb-lookup.model';
import { forkJoin } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ToastrService } from 'ngx-toastr';
import { NotificationService } from 'src/app/common/events/notificationservice';
@Component({
  selector: 'app-calander',
  templateUrl: './calander.component.html',
  styleUrls: ['./calander.component.css']
})
export class CalanderComponent implements OnInit {
  @ViewChild('fullcalendar') calendarComponent!: FullCalendarComponent;
  selectedEvent: any = null;
  filters = {
    type: '',
    search: '',
    staffName: '0',
    status: '0',
    category: '0'
  };
  statusType: String
  pageSize = 10;
  pageIndex = 0;
  totalRecords = 0;
  staffName: string = '0'
  minDateTime: string;
  allStaffRecords: any;
  allStaffRecordsList: any;
  constructor(
    private rsbService: RsbService,
    private rsbLookup: RsbLookupModel,
    private snackBar: MatSnackBar,
    private toast: ToastrService,
    private notify: NotificationService

  ) { }

  ngOnInit(): void {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');


    // Format: YYYY-MM-DDTHH:mm (HTML5 datetime-local format)
    this.minDateTime = `${year}-${month}-${day}`;
    this.getCalendarData()
  }



  calendarOptions: CalendarOptions = {
    initialView: 'timeGridDay',   // shows only current day with time
    initialDate: new Date(),
    headerToolbar: {
      left: '',     // remove prev/next buttons
      center: 'title',
      right: ''     // remove view switcher
    },
    slotMinTime: "08:00:00",   // morning 8 AM
    slotMaxTime: "21:00:00",   // night 9 PM
    nowIndicator: true, // red line for current time
    allDaySlot: false,  // hide "all-day" row if you don’t want it
    contentHeight: 'auto',   // 👈 remove scrollbar, fit height automatically
    expandRows: true,
    slotDuration: '00:30:00', // 30-min slots
    events: [

    ],




    eventMouseEnter: (info) => {
      // highlight if you want
      info.el.style.backgroundColor = '#ffcccc';

      // log full event object
      console.log('Hovered Event Object:', info.event);

      // access values
      console.log('ID:', info.event.id);
      console.log('Title:', info.event.title);
      console.log('Start:', info.event.start);
      console.log('End:', info.event.end);
      console.log('Extra Data:', info.event.extendedProps); // custom fields

      // if you want to show tooltip on hover
      const tooltip = document.createElement('div');
      tooltip.innerHTML = `
    <strong>${info.event.title}</strong><br>
    Time: ${info.event.start}<br>
    remarks: ${info.event.extendedProps.remarks || 'None'}<br>
    property: ${info.event.extendedProps.property || 'None'}
  `;
      tooltip.style.position = 'absolute';
      tooltip.style.background = '#fff';
      tooltip.style.border = '1px solid #ccc';
      tooltip.style.padding = '5px';
      tooltip.style.zIndex = '1000';
      document.body.appendChild(tooltip);

      // follow mouse
      info.el.addEventListener('mousemove', (e) => {
        tooltip.style.left = e.pageX + 10 + 'px';
        tooltip.style.top = e.pageY + 10 + 'px';
      });

      // remove tooltip on leave
      info.el.addEventListener('mouseleave', () => {
        tooltip.remove();
      });
    },

    // when you move mouse away
    eventMouseLeave: (info) => {
      info.el.style.backgroundColor = ''; // reset back
    },
    eventClick: (info) => {
      this.selectedEvent = info.event;
    }
  };


  getCalendarData(date?: string): void {
    forkJoin({
      followups: this.rsbService.getCalanderFollowup(date),
      opportunities: this.rsbService.getOppCalanderFollowup(date)
    }).subscribe(({ followups, opportunities }) => {
      let events: any[] = [];

      // ✅ process followup events
      if (followups.statusCode === 0 && followups.contents.length) {
        const followupEvents = followups.contents.map((record: any, index: number) => {
          const start = new Date(record.date);
          return {
            id: record.leadId || 'F-' + index,
            title: 'Follow Up - ' + record.customerName,
            start: start.toISOString(),
            extendedProps: {
              mobile: record.mobile,
              email: record.email,
              staff: record.staffId,
              remarks: record.description,
              property: record.propertyTitle,
              productValue: record.price,
              name: record.customerName,
              source: 'followup'
            }
          };
        });
        events = [...events, ...followupEvents];
      }

      // ✅ process opportunity events
      if (opportunities.statusCode === 0 && opportunities.contents.length) {
        const oppEvents = opportunities.contents.map((record: any, index: number) => {
          const start = new Date(record.date);
          return {
            id: record.leadId || 'O-' + index,
            title: 'Opportunity - ' + record.customerName,
            start: start.toISOString(),
            extendedProps: {
              mobile: record.mobile,
              email: record.email,
              staff: record.staffId,
              remarks: record.remarks,
              property: record.propertyTitle,
              productValue: record.price,
              name: record.customerName,
              source: 'opportunity'
            }
          };
        });
        events = [...events, ...oppEvents];
        this.notify.setEvents(events)
      }

      // ✅ update calendar
      this.calendarOptions = {
        ...this.calendarOptions,
        events: events
      };
    });

  }

  onDateChange(event: any) {
    this.selectedEvent = null;
    const selectedDate = new Date(event.target.value);
    const calendarApi = this.calendarComponent.getApi();

    // ✅ Navigate to selected date
    calendarApi.gotoDate(selectedDate);
    this.getCalendarData(event.target.value)

  }

}
